import React from 'react';
import { Heart, Shield, Handshake, Scale, Sprout, Target } from 'lucide-react';
export function CoreValuesSection() {
  const values = [{
    icon: <Heart className="w-8 h-8" data-id="element-61" />,
    title: 'Compassion',
    description: 'We serve with empathy, dignity, and genuine concern for those we support.',
    color: 'bg-accent',
    borderColor: 'border-accent'
  }, {
    icon: <Shield className="w-8 h-8" data-id="element-62" />,
    title: 'Integrity',
    description: 'We uphold the highest standards of transparency, accountability, and ethical conduct in all our activities.',
    color: 'bg-primary',
    borderColor: 'border-primary'
  }, {
    icon: <Handshake className="w-8 h-8" data-id="element-63" />,
    title: 'Partnership',
    description: 'We believe meaningful impact is achieved through collaboration with governments, donors, organizations, and local communities.',
    color: 'bg-secondary',
    borderColor: 'border-secondary'
  }, {
    icon: <Scale className="w-8 h-8" data-id="element-64" />,
    title: 'Equity',
    description: 'We promote inclusion and fairness, ensuring no one is left behind in our service delivery.',
    color: 'bg-primary',
    borderColor: 'border-primary'
  }, {
    icon: <Sprout className="w-8 h-8" data-id="element-65" />,
    title: 'Sustainability',
    description: 'We design long-term solutions that create lasting change and strengthen community resilience.',
    color: 'bg-secondary',
    borderColor: 'border-secondary'
  }];
  return <section className="py-24 bg-gradient-to-b from-warm-ivory to-white overflow-hidden" data-id="element-66">
      <div className="container mx-auto px-4" data-id="element-67">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-68">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4" data-id="element-69">
            Our Core Values
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-70">
            Guided by Principles That Matter
          </h2>
          <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-71">
            Our values shape every decision we make and every life we touch.
            They are the foundation of our commitment to creating meaningful,
            lasting change.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-72">
          {values.map((value, index) => <div key={index} className={`bg-white rounded-2xl p-8 shadow-soft hover:shadow-hover transition-all duration-300 hover:-translate-y-1 border-l-4 ${value.borderColor} group animate-fadeInUp`} style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-73">
              <div className={`w-16 h-16 rounded-xl ${value.color} bg-opacity-10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-74">
                <div className={`${value.color.replace('bg-', 'text-')}`} data-id="element-75">
                  {value.icon}
                </div>
              </div>
              <h3 className="text-2xl font-serif font-bold text-charcoal mb-3" data-id="element-76">
                {value.title}
              </h3>
              <p className="text-neutral-600 leading-relaxed" data-id="element-77">
                {value.description}
              </p>
            </div>)}
        </div>

        {/* Mission & Vision */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-78">
          {/* Vision */}
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-3xl p-8 md:p-10 border border-primary/20" data-id="element-79">
            <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center mb-6" data-id="element-80">
              <Sprout className="w-7 h-7 text-primary" data-id="element-81" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-82">
              Our Vision
            </h3>
            <p className="text-neutral-700 leading-relaxed text-lg" data-id="element-83">
              A society where every individual has access to basic human needs
              such as food, quality healthcare, education, and safe living
              conditions, and where communities are empowered to thrive free
              from poverty and deprivation.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-gradient-to-br from-secondary/5 to-secondary/10 rounded-3xl p-8 md:p-10 border border-secondary/20" data-id="element-84">
            <div className="w-14 h-14 rounded-full bg-secondary/20 flex items-center justify-center mb-6" data-id="element-85">
              <Target className="w-7 h-7 text-secondary" data-id="element-86" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-87">
              Our Mission
            </h3>
            <p className="text-neutral-700 leading-relaxed text-lg" data-id="element-88">
              To empower individuals and communities through sustainable
              agricultural development, humanitarian interventions, accessible
              healthcare initiatives, and social support systems, while
              fostering partnerships that promote inclusive growth and national
              development.
            </p>
          </div>
        </div>
      </div>
    </section>;
}